mutation MessageApprovalCreate($input: MessageApprovalCreateInput!) {
  messageApprovalCreate(input: $input) {
    userMessages {
      id
      messageComment
    }
  }
}
